import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SettingsComponent } from './settings.component';

const settingsRoutes: Routes = [
  {
    path: '',
    component: SettingsComponent,
    children: [
      {
        path: 'billing',
        redirectTo: 'account/billing',
      },
      {
        path: 'preferences',
        loadChildren: () => import(/* webpackChunkName: "manager-preferences" */ './preferences/preferences.module')
          .then(module => module.PreferencesModule),
      },
      {
        path: 'location',
        loadChildren: () => import(/* webpackChunkName: "manager-location" */ './location/location.module')
          .then(module => module.LocationModule),
      },
      {
        path: 'account',
        loadChildren: () => import(/* webpackChunkName: "manager-account" */ './account/account.module')
          .then(module => module.AccountModule),
      },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(settingsRoutes)
  ],
  exports: [
    RouterModule
  ],
})
export class SettingsRoutingModule {}
